module.exports = __webpack_public_path__ + "static/fonts/Mont-Regular.abb74a5.ttf";